import { makeStyles } from "@mui/styles";
import React, { useState, useContext, useEffect } from "react";
import { store } from "../contexts/store";
import { CloseIcon, DocumentationIcon } from "../icons";
import { InputBase, Typography, Button, Icon } from "@mui/material";
import styles from "./fieldsStats.module.css";
import SustainabilityLineChart from "./SustainabiltyLineChart";
import TimeSeriesChart from "./TimseSeriesChart";
import { setFeature } from "../contexts/actions";
import { saveAs } from "file-saver";
import { indexName, indexDesc } from "../config";

const useStyles = makeStyles((theme) => ({
  infoIcon: {
    fill: "none",
    marginRight: 4,
  },
}));

const FieldStats = (props) => {
  const classes = useStyles();
  const {
    state: { feature, location, indexName },
    dispatch,
  } = useContext(store);

  // useEffect(() => {
  //   console.log("features-----------------", feature);
  //   // console.log(JSON.parse(feature.properties.yearly_data));
  // }, [feature]);

  const downloadGeoJSON = () => {
    const featureGeojson = {
      ...feature,
    };
    const blob = new Blob([JSON.stringify(featureGeojson, null, 2)], {
      type: "application/json",
    });
    saveAs(blob, `Field-${feature.id}.json`);
  };

  const getPercentileDisplay = (percentage) => {
    const prefix = percentage > 50 ? "Top" : "Bottom";

    if (percentage >= 95) {
      return `${prefix} 5`;
    } else if (percentage >= 50) {
      return `${prefix} ${
        100 -
        Math.floor(
          parseInt(
            feature.properties[`localpc_${indexName}`]
              ? feature.properties[`localpc_${indexName}`]
              : feature.properties.localpc
          ) / 10
        ) *
          10
      }`;
    } else {
      return `${prefix} ${Math.max(
        Math.ceil(
          parseInt(
            feature.properties[`localpc_${indexName}`]
              ? feature.properties[`localpc_${indexName}`]
              : feature.properties.localpc
          ) / 10
        ) * 10,
        10
      )}`;
    }
  };
  // Display the two input fields always.
  // Once the field is selected, fill the input. It doesn't have to be an input field.
  // Just make sure that on clicking the close button it gets cleared.
  // When the field details are present, display the graphs.
  // For the graphs, use whatever library was used in time series.
  // Years can probably be taken from the url.
  // The table name has to come from the url. That we can worry about in the map page component.

  //   The selcted field needs to be highlighted on the map. And probably on second click get unselected
  return (
    <div className={styles.rootFieldStats}>
      <div className={styles.info}>
        <div className={styles.fieldStatsHeader}>
          <div>
            {feature.id}
            <div className={styles.infoSmallLabel}>Field Id</div>
          </div>
          <div className={styles.flex1}>
            {parseFloat(parseFloat(feature.properties.area) / 10000).toFixed(2)}
            <div className={styles.infoSmallLabel}>Area</div>
          </div>
          <div>
            {indexName !== "fields" &&
              indexName !== "Deforestation" &&
              indexName !== "crop" &&
              indexName !== "timeseries" && (
                <>
                  {parseFloat(feature.properties[indexName]).toFixed(3)}
                  <div className={styles.infoSmallLabel}>
                    {indexName === "SustInd" ? "SustInd" : "BSI"}
                  </div>
                </>
              )}
          </div>
        </div>
      </div>
      <div className={styles.divider}></div>
      {indexName !== "fields" &&
        indexName !== "Deforestation" &&
        indexName !== "crop" &&
        indexName !== "timeseries" && (
          <div className={styles.info}>
            <div className={styles.fbiTitle}>
              {indexName === "SustInd"
                ? "Long Term Sustainability Index"
                : "Long Term Soil Exposure Benchmark Index"}
            </div>
          </div>
        )}
      {indexName !== "fields" &&
        indexName !== "Deforestation" &&
        indexName !== "crop" &&
        indexName !== "timeseries" && (
          <div className={styles.info}>
            <div className={styles.fbiDisplay}>
              <div className={styles.fbiDisplayTitle}>Local</div>
              <div className={styles.displayBarContainer}>
                <div className={styles.displayBarBackground}>
                  <div
                    className={styles.displayBar}
                    style={{
                      maxWidth:
                        parseInt(
                          feature.properties[`localpc_${indexName}`]
                            ? feature.properties[`localpc_${indexName}`]
                            : feature.properties.localpc
                        ) + "%",
                    }}
                  ></div>
                  <div className={styles.infoSmallLabelGreen}>
                    #
                    {feature.properties[`localrank_${indexName}`]
                      ? feature.properties[`localrank_${indexName}`]
                      : feature.properties.localrank}
                  </div>
                </div>
              </div>
              <div className={styles.fbiStat}>
                <div className={styles.fbiStatTitle}>
                  {getPercentileDisplay(
                    parseInt(
                      feature.properties[`localpc_${indexName}`]
                        ? feature.properties[`localpc_${indexName}`]
                        : feature.properties.localpc
                    )
                  )}
                  %
                </div>
                <div className={styles.infoSmallLabel}>
                  {`out of ${feature.properties.localcount}`}
                </div>
              </div>
            </div>
          </div>
        )}

      {indexName === "crop" && (
        <div className={styles.info}>
          <div className={styles.fbiTitle}>
            <h4>
              Crop:{" "}
              {feature.properties["predicted_crop"] !== "null"
                ? feature.properties["predicted_crop"]
                : "Unknown"}
            </h4>
          </div>
        </div>
      )}

      {indexName === "Deforestation" && (
        <div className={styles.info}>
          {feature.properties["deforestation_year"] && (
            <div className={styles.fbiDisplay}>
              <div className={styles.fbiDisplayTitle}>
                Deforestation Year : {feature.properties["deforestation_year"]}{" "}
              </div>
            </div>
          )}
        </div>
      )}

      {/* <SustainabilityLineChart data={JSON.parse(feature.properties.SustInd)} /> */}
      <div className={styles.exportButtonContainer}>
        <Button
          className={styles.exportButton}
          onClick={downloadGeoJSON}
          disabled={feature.properties.uploadedPolygon}
        >
          <DocumentationIcon classes={{ root: classes.infoIcon }} />
          <Typography variant="body2" fontWeight={700}>
            Save as Geojson
          </Typography>
        </Button>
      </div>
    </div>
  );
};

export default FieldStats;
